import * as Yup from "yup";
import { APP_CONFIG } from "../../../constants/constants";
import { phoneRegex } from "../../../utils/validation";

// form field names
export type TFormFieldNames =
  | "categoryid"
  | "displayname"
  | "description"
  | "notes"
  | "geozones"
  | "users";

// initial values for the form
export const geozoneCategoryDetailsInitialValues = {
  categoryid: "",
  displayname: "",
  description: "",
  notes: "",
  geozones: [] as string[] | { label: string; value: string }[],
  users: [] as string[] | { label: string; value: string }[],
};

// validation schema for the form
export const geozoneCategoryDetailsYupValidationSchema = Yup.object().shape({
  categoryid: Yup.string().required("Geozone Category ID is required"),
  displayname: Yup.string().required("Display Name is required"),
  description: Yup.string().required("Description is required"),
  notes: Yup.string(),
  geozones: Yup.array().of(Yup.object()).min(1, "At least one geozone must be selected"),
  users: Yup.array().of(Yup.object()),
});
